/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'grflag': {
    width: 16,
    height: 16,
    viewBox: '0 0 401.3 400',
    data: '<path pid="0" class="st0" d="M201-.1c-2.1 0-4.2 0-6.3.1h12.6c-2.1-.1-4.2-.1-6.3-.1z"/><path pid="1" class="st1" d="M92.6 32.1C69.2 47.4 49.1 67.5 34 91.1h58.6v-59zM201 396.9c46.9 0 90.1-16.3 124.1-43.6H76.9c34 27.3 77.2 43.6 124.1 43.6zM39.1 313.3h323.7c10.6-14.9 19.2-31.3 25.4-48.9H13.8c6.2 17.6 14.7 34 25.3 48.9zM132.6 91.1h91.1v40h-91.1v93.3h265.2c1.1-8.5 1.7-17.2 1.7-26.1 0-7.7-.5-15.3-1.3-22.8H223.7v-40h165.6c-5.8-17.5-14-33.9-24.3-48.9H223.7v-40H329C295.9 18.8 253.6 1.4 207.3 0h-12.6c-21.8.7-42.6 4.9-62.1 12v79.1zM92.6 131.1H14.2c-7.6 21-11.7 43.7-11.7 67.3 0 8.8.6 17.5 1.7 26.1h88.4v-93.4z"/><path pid="2" class="st2" d="M223.7 175.6h174.5c-1.6-13.8-4.6-27.2-8.8-40H223.7v40zM223.7 86.7h141.4c-10.2-14.9-22.3-28.4-36.1-40H223.7v40z"/><path pid="3" class="st2" d="M132.6 131.1h91.1v-40h-91.1V12c-14.2 5.2-27.6 12-40 20.1v59H34c-8 12.4-14.7 25.9-19.8 40h78.4v93.3H4.2c1.8 13.8 5.1 27.2 9.6 40h374.5c4.5-12.8 7.8-26.2 9.6-40H132.6v-93.3zM76.9 353.3H325c14.4-11.5 27.1-25 37.8-40H39.1c10.7 15.1 23.5 28.5 37.8 40z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/grflag.js